<template>
  <div class="data-line">
    <div class="chart-wrap">
      <div class="chart-header flex-wrap">
        <div class="main-font-color title">{{ title }}</div>
      </div>
      <div class="chart-body">
        <div ref="chart" class="chart-content" />
        <div class="item-info">
          <div
            v-for="(item, index) in legendName"
            :key="index"
            class="item-title"
          >
            {{ item }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'
export default {
  name: 'DataLine',
  props: {
    echartsData: Array,
    title: String,
    name: String,
    legend: String,
    unit: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      attr: [],
      legendName: [],
      dateList: [],
      valueList: [],
      color: ['#4c84ff', '#34c6ac'],
      legendList: []
    }
  },
  watch: {
    echartsData() {
      this.initData()
    }
  },
  mounted() {
    this.initData()
  },
  methods: {
    initData() {
      this.attr = this.name
      const me = this
      this.attr = this.attr.split(',')
      this.legendName = this.legend
      this.legendName = this.legendName.split(',')
      this.dateList = this.echartsData.map(item => {
        return item.date
      })
      this.valueList = []
      for (let i = 0; i < this.attr.length; i++) {
        this.valueList.push({
          type: 'line',
          showSymbol: true,
          smooth: true,
          itemStyle: {
            normal: {
              color: me.color[i],
              lineStyle: {
                color: me.color[i]
              }
            }
          },
          data: []
        })
        this.legendList.push(this.legendName[i])
        for (let j = 0; j < this.echartsData.length; j++) {
          this.valueList[i].data.push(this.echartsData[j][this.attr[i]])
        }
      }
      this.drawPie()
    },
    drawPie() {
      const pie = echarts.init(this.$refs.chart)
      const me = this
      pie.setOption({
        // visualMap: [{
        //   show: false,
        //   type: 'continuous',
        //   seriesIndex: 1,
        //   dimension: 0,
        //   min: 0,
        //   max: this.dateList.length - 1
        // }],
        tooltip: {
          trigger: 'axis',
          formatter: function(params) {
            let relVal = params[0].name
            for (let i = 0, l = params.length; i < l; i++) {
              relVal += '<br/>' + params[i].marker + params[i].value + me.unit
            }
            return relVal
          }
        },
        xAxis: {
          type: 'category',
          axisLine: {
            lineStyle: {
              color: '#bbb'
            }
          },
          data: this.dateList
        },
        yAxis: {
          type: 'value',
          axisLine: {
            lineStyle: {
              color: '#bbb'
            }
          },
          splitLine: {
            lineStyle: {
              color: '#f2f2f2'
            }
          }
        },
        series: this.valueList
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.chart-wrap {
  margin-bottom: 50px;
  width: 760px;
  .chart-header {
    background-color: #f0f3fa;
    height: 60px;
    line-height: 60px;
    padding: 0 30px;
    justify-content: space-between;
    .title {
      font-size: 16px;
    }
    .total {
      font-size: 14px;
    }
  }
  .chart-body {
    height: 350px;
    background-color: #fafafa;
    .chart-content {
      width: 760px;
      height: 350px;
      div {
        width: 100px !important;
      }
    }
    .item-list {
      flex: 1;
      height: 100%;
      padding: 85px 50px;
      box-sizing: border-box;
      justify-content: space-between;
      align-content: space-between;
      flex-wrap: wrap;
      position: relative;
      :before {
        content: "";
        position: absolute;
        left: 0;
        top: 50%;
        transform: translate(0, -50%);
        width: 2px;
        height: 180px;
        background-color: #d9d9d9;
      }
      .item-content {
        width: 50%;
        .item-icon {
          box-sizing: border-box;
          width: 14px;
          height: 14px;
          border-radius: 50%;
          border-width: 3px;
          border-style: solid;
          border-color: #333;
        }
        .item-info {
          overflow: hidden;
          padding-left: 10px;
          font-size: 14px;
          .item-title {
            color: $color_black;
            margin-bottom: 10px;
          }
          .item-total {
            color: $color_normal;
          }
        }
      }
    }
  }
  .item-info {
    display: block;
    width: 100%;
    text-align: center;
    div {
      display: inline-block;
      margin: 10px 20px;
      padding-left: 25px;
      font-size: 14px;
      color: #333;
    }
    div:nth-child(n) {
      background: url(../../assets/img/icon2.png) left center no-repeat;
      background-size: 15px 15px;
    }
    div:nth-child(2n) {
      background: url(../../assets/img/icon1.png) left center no-repeat;
      background-size: 15px 15px;
    }
  }
}
</style>
